import { render, staticRenderFns } from "./PnetMessageNewSideMenu.vue?vue&type=template&id=ead60d6a"
import script from "./PnetMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ead60d6a')) {
      api.createRecord('ead60d6a', component.options)
    } else {
      api.reload('ead60d6a', component.options)
    }
    module.hot.accept("./PnetMessageNewSideMenu.vue?vue&type=template&id=ead60d6a", function () {
      api.rerender('ead60d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageNewSideMenu.vue"
export default component.exports